import { string } from 'prop-types';
import React from 'react';
import { TbFiles, TbDownload } from 'react-icons/tb';

function PdfFileDownload({ type = '', product = ''}) {
    let color, text, pdfFile;

    switch(type){
        case 'individu':
            color = "#597B06";
            break;
        default:
            color = "#036A80";
            break;
    }

    switch (product) {
        case "kasbon":
            text = "Emergency Loan";
            pdfFile = "pdf-dummy1";
            break;
        case "ebp":
            text = "Employee Benefit";
            pdfFile = "RIPLAY DANAI.ID - Employee Benefit";
            break;
        case "kmg":
            text = "Kredit Multiguna";
            pdfFile = "RIPLAY DANAI.ID - Kredit Multiguna";
            break;
        case "invoice":
            text = "Invoice Financing";
            pdfFile = "RIPLAY DANAI.ID - Invoice Financing";
            break;
        case "inventory":
            text = "Inventory Financing";
            pdfFile = "RIPLAY DANAI.ID - Inventory Financing";
            break;
        case "developer":
            text = "Developer Financing";
            pdfFile = "RIPLAY DANAI.ID - Developer Financing";
            break;

        default:
            text = "Pendanaan";
            pdfFile = "pdf-dummy4";
    }

    return (
        <div className='text-container'>
            <h2 className='text-header'>Dokumen Ringkasan Informasi Produk Dan Layanan (RIPLAY)</h2>
            {   product === 'ebp' ? 
                <p>Download dokumen RIPLAY Umum untuk mendapatkan informasi lebih lengkap mengenai produk <em>Employee Benefit Program</em> (EBP) di Danai.id</p>
                : product === 'kmg' ?
                    <p>Download dokumen RIPLAY Umum untuk mendapatkan informasi lebih lengkap mengenai produk Kredit Multiguna di Danai.id</p>    
                : product === 'invoice' ?
                    <p>Download dokumen RIPLAY Umum untuk mendapatkan informasi lebih lengkap mengenai produk <em>Invoice Financing</em> di Danai.id</p>
                : product === 'inventory' ?
                    <p>Download dokumen RIPLAY Umum untuk mendapatkan informasi lebih lengkap mengenai produk <em>Inventory Financing</em> di Danai.id</p>
                
                : <p>Download dokumen RIPLAY Umum untuk mendapatkan informasi lebih lengkap mengenai produk <em>Developer Financing</em> di Danai.id</p>
                }
            <a
                className="download-document"
                href={require(`../../../../assets/pdf/${pdfFile}.pdf`)}
                download={`RIPLAY DANAI.ID - ${text}.pdf`}
            >
                <div className="left">
                    <TbFiles size={24} color={color} />
                    <p style={{color:color}}>
                        RIPLAY Umum Danai.id - {text}
                    </p>
                </div>
                <TbDownload size={24} color={color} />
            </a>
        </div>
    );
}

export default function Riplay({type, product}){
    return (
        <div className={`container-alur riplay ${type === 'individu' ? 'individu' : type === 'produktif' ? 'produktif' : 'pendanaan'}`}>
            <PdfFileDownload type={type} product={product}/>
        </div>
    );
}